export class Network {
  socket?: WebSocket;
  room: any = null;
  players = new Map<string, any>();
  ping = 0;
  onLobby = (room: any) => {};
  onEvent = (message: string) => {};
  onFinish = (result: any) => {};
  private reconnect?: ReturnType<typeof setTimeout>;
  private stopped = false;
  private sentStates = 0;
  private receivedSnapshots = 0;
  private sampledAt = performance.now();
  private rates = { networkHz: 0, networkReceiveHz: 0 };
  metrics(now: number) {
    const elapsed = now - this.sampledAt;
    if (elapsed >= 1000) {
      this.rates = {
        networkHz: Math.round((this.sentStates * 1000) / elapsed),
        networkReceiveHz: Math.round((this.receivedSnapshots * 1000) / elapsed),
      };
      this.sentStates = this.receivedSnapshots = 0;
      this.sampledAt = now;
    }
    return this.rates;
  }
  connect() {
    this.stopped = false;
    const ws = new WebSocket(location.origin.replace(/^http/, "ws") + "/ws");
    this.socket = ws;
    ws.onmessage = (e) => {
      const msg = JSON.parse(e.data);
      if (msg.type === "connected" && this.room)
        this.send({ type: "join", code: this.room.code });
      if (msg.type === "lobby") {
        this.room = msg;
        this.players.clear();
        this.onLobby(msg);
      }
      if (msg.type === "left") {
        this.room = null;
        this.players.clear();
        this.onLobby(null);
      }
      if (msg.type === "snapshot") {
        this.receivedSnapshots++;
        for (const p of msg.players) this.players.set(p.id, p);
      }
      if (msg.type === "finish") this.onFinish(msg.result);
      if (msg.type === "error") this.onEvent(msg.error);
      if (msg.type === "pong")
        this.ping = Math.round(performance.now() - msg.at);
    };
    ws.onclose = () => {
      if (!this.stopped) {
        this.onEvent("Connection lost. Reconnecting…");
        this.reconnect = setTimeout(() => this.connect(), 2500);
      }
    };
  }
  send(data: unknown) {
    if (this.socket?.readyState === WebSocket.OPEN) {
      this.socket.send(JSON.stringify(data));
      if ((data as any)?.type === "state") this.sentStates++;
    }
  }
  close() {
    this.stopped = true;
    clearTimeout(this.reconnect);
    this.socket?.close();
    this.room = null;
    this.players.clear();
  }
}
